/**
 * Comprehensive world countries list with ISO 3166-1 alpha-2 codes and dial codes.
 * Flags are rendered via https://flagcdn.com using the country code.
 *
 * Usage:
 *   import { countries, getFlag, findByCode } from '@/utils/countries';
 *   getFlag('cm')       → 'https://flagcdn.com/w40/cm.png'
 *   getFlag('cm', 20)   → 'https://flagcdn.com/w20/cm.png'
 */

export function getFlag(code, width = 40) {
  return `https://flagcdn.com/w${width}/${code.toLowerCase()}.png`;
}

export function findByCode(code) {
  return countries.find(c => c.code === code.toUpperCase());
}

export const countries = [
  // ── Africa ──
  { name: 'Cameroon', dial_code: '237', code: 'CM' },
  { name: 'Nigeria', dial_code: '234', code: 'NG' },
  { name: 'Ghana', dial_code: '233', code: 'GH' },
  { name: 'Kenya', dial_code: '254', code: 'KE' },
  { name: 'South Africa', dial_code: '27', code: 'ZA' },
  { name: 'Egypt', dial_code: '20', code: 'EG' },
  { name: 'Morocco', dial_code: '212', code: 'MA' },
  { name: 'Algeria', dial_code: '213', code: 'DZ' },
  { name: 'Tunisia', dial_code: '216', code: 'TN' },
  { name: 'Libya', dial_code: '218', code: 'LY' },
  { name: 'Senegal', dial_code: '221', code: 'SN' },
  { name: 'Mali', dial_code: '223', code: 'ML' },
  { name: 'Guinea', dial_code: '224', code: 'GN' },
  { name: "Côte d'Ivoire", dial_code: '225', code: 'CI' },
  { name: 'Burkina Faso', dial_code: '226', code: 'BF' },
  { name: 'Niger', dial_code: '227', code: 'NE' },
  { name: 'Togo', dial_code: '228', code: 'TG' },
  { name: 'Benin', dial_code: '229', code: 'BJ' },
  { name: 'Mauritania', dial_code: '222', code: 'MR' },
  { name: 'Gabon', dial_code: '241', code: 'GA' },
  { name: 'Republic of the Congo', dial_code: '242', code: 'CG' },
  { name: 'DR Congo', dial_code: '243', code: 'CD' },
  { name: 'Central African Republic', dial_code: '236', code: 'CF' },
  { name: 'Chad', dial_code: '235', code: 'TD' },
  { name: 'Equatorial Guinea', dial_code: '240', code: 'GQ' },
  { name: 'Rwanda', dial_code: '250', code: 'RW' },
  { name: 'Burundi', dial_code: '257', code: 'BI' },
  { name: 'Angola', dial_code: '244', code: 'AO' },
  { name: 'Mozambique', dial_code: '258', code: 'MZ' },
  { name: 'Zambia', dial_code: '260', code: 'ZM' },
  { name: 'Zimbabwe', dial_code: '263', code: 'ZW' },
  { name: 'Malawi', dial_code: '265', code: 'MW' },
  { name: 'Tanzania', dial_code: '255', code: 'TZ' },
  { name: 'Uganda', dial_code: '256', code: 'UG' },
  { name: 'Ethiopia', dial_code: '251', code: 'ET' },
  { name: 'Somalia', dial_code: '252', code: 'SO' },
  { name: 'Sudan', dial_code: '249', code: 'SD' },
  { name: 'South Sudan', dial_code: '211', code: 'SS' },
  { name: 'Eritrea', dial_code: '291', code: 'ER' },
  { name: 'Djibouti', dial_code: '253', code: 'DJ' },
  { name: 'Madagascar', dial_code: '261', code: 'MG' },
  { name: 'Mauritius', dial_code: '230', code: 'MU' },
  { name: 'Namibia', dial_code: '264', code: 'NA' },
  { name: 'Botswana', dial_code: '267', code: 'BW' },
  { name: 'Lesotho', dial_code: '266', code: 'LS' },
  { name: 'Eswatini', dial_code: '268', code: 'SZ' },
  { name: 'Gambia', dial_code: '220', code: 'GM' },
  { name: 'Guinea-Bissau', dial_code: '245', code: 'GW' },
  { name: 'Cape Verde', dial_code: '238', code: 'CV' },
  { name: 'Sierra Leone', dial_code: '232', code: 'SL' },
  { name: 'Liberia', dial_code: '231', code: 'LR' },
  { name: 'São Tomé and Príncipe', dial_code: '239', code: 'ST' },
  { name: 'Comoros', dial_code: '269', code: 'KM' },
  { name: 'Seychelles', dial_code: '248', code: 'SC' },

  // ── Europe ──
  { name: 'France', dial_code: '33', code: 'FR' },
  { name: 'Germany', dial_code: '49', code: 'DE' },
  { name: 'United Kingdom', dial_code: '44', code: 'GB' },
  { name: 'Italy', dial_code: '39', code: 'IT' },
  { name: 'Spain', dial_code: '34', code: 'ES' },
  { name: 'Portugal', dial_code: '351', code: 'PT' },
  { name: 'Netherlands', dial_code: '31', code: 'NL' },
  { name: 'Belgium', dial_code: '32', code: 'BE' },
  { name: 'Switzerland', dial_code: '41', code: 'CH' },
  { name: 'Austria', dial_code: '43', code: 'AT' },
  { name: 'Sweden', dial_code: '46', code: 'SE' },
  { name: 'Norway', dial_code: '47', code: 'NO' },
  { name: 'Denmark', dial_code: '45', code: 'DK' },
  { name: 'Finland', dial_code: '358', code: 'FI' },
  { name: 'Poland', dial_code: '48', code: 'PL' },
  { name: 'Czech Republic', dial_code: '420', code: 'CZ' },
  { name: 'Romania', dial_code: '40', code: 'RO' },
  { name: 'Hungary', dial_code: '36', code: 'HU' },
  { name: 'Greece', dial_code: '30', code: 'GR' },
  { name: 'Ireland', dial_code: '353', code: 'IE' },
  { name: 'Luxembourg', dial_code: '352', code: 'LU' },
  { name: 'Bulgaria', dial_code: '359', code: 'BG' },
  { name: 'Croatia', dial_code: '385', code: 'HR' },
  { name: 'Slovakia', dial_code: '421', code: 'SK' },
  { name: 'Slovenia', dial_code: '386', code: 'SI' },
  { name: 'Serbia', dial_code: '381', code: 'RS' },
  { name: 'Ukraine', dial_code: '380', code: 'UA' },
  { name: 'Russia', dial_code: '7', code: 'RU' },
  { name: 'Turkey', dial_code: '90', code: 'TR' },
  { name: 'Iceland', dial_code: '354', code: 'IS' },
  { name: 'Malta', dial_code: '356', code: 'MT' },
  { name: 'Cyprus', dial_code: '357', code: 'CY' },
  { name: 'Estonia', dial_code: '372', code: 'EE' },
  { name: 'Latvia', dial_code: '371', code: 'LV' },
  { name: 'Lithuania', dial_code: '370', code: 'LT' },
  { name: 'Albania', dial_code: '355', code: 'AL' },
  { name: 'Bosnia and Herzegovina', dial_code: '387', code: 'BA' },
  { name: 'Montenegro', dial_code: '382', code: 'ME' },
  { name: 'North Macedonia', dial_code: '389', code: 'MK' },
  { name: 'Moldova', dial_code: '373', code: 'MD' },
  { name: 'Belarus', dial_code: '375', code: 'BY' },
  { name: 'Georgia', dial_code: '995', code: 'GE' },
  { name: 'Armenia', dial_code: '374', code: 'AM' },
  { name: 'Azerbaijan', dial_code: '994', code: 'AZ' },

  // ── Americas ──
  { name: 'United States', dial_code: '1', code: 'US' },
  { name: 'Canada', dial_code: '1', code: 'CA' },
  { name: 'Mexico', dial_code: '52', code: 'MX' },
  { name: 'Brazil', dial_code: '55', code: 'BR' },
  { name: 'Argentina', dial_code: '54', code: 'AR' },
  { name: 'Colombia', dial_code: '57', code: 'CO' },
  { name: 'Chile', dial_code: '56', code: 'CL' },
  { name: 'Peru', dial_code: '51', code: 'PE' },
  { name: 'Venezuela', dial_code: '58', code: 'VE' },
  { name: 'Ecuador', dial_code: '593', code: 'EC' },
  { name: 'Bolivia', dial_code: '591', code: 'BO' },
  { name: 'Paraguay', dial_code: '595', code: 'PY' },
  { name: 'Uruguay', dial_code: '598', code: 'UY' },
  { name: 'Costa Rica', dial_code: '506', code: 'CR' },
  { name: 'Panama', dial_code: '507', code: 'PA' },
  { name: 'Guatemala', dial_code: '502', code: 'GT' },
  { name: 'Honduras', dial_code: '504', code: 'HN' },
  { name: 'El Salvador', dial_code: '503', code: 'SV' },
  { name: 'Nicaragua', dial_code: '505', code: 'NI' },
  { name: 'Dominican Republic', dial_code: '1809', code: 'DO' },
  { name: 'Cuba', dial_code: '53', code: 'CU' },
  { name: 'Haiti', dial_code: '509', code: 'HT' },
  { name: 'Jamaica', dial_code: '1876', code: 'JM' },
  { name: 'Trinidad and Tobago', dial_code: '1868', code: 'TT' },
  { name: 'Guyana', dial_code: '592', code: 'GY' },
  { name: 'Suriname', dial_code: '597', code: 'SR' },

  // ── Asia ──
  { name: 'China', dial_code: '86', code: 'CN' },
  { name: 'Japan', dial_code: '81', code: 'JP' },
  { name: 'South Korea', dial_code: '82', code: 'KR' },
  { name: 'India', dial_code: '91', code: 'IN' },
  { name: 'Pakistan', dial_code: '92', code: 'PK' },
  { name: 'Bangladesh', dial_code: '880', code: 'BD' },
  { name: 'Indonesia', dial_code: '62', code: 'ID' },
  { name: 'Philippines', dial_code: '63', code: 'PH' },
  { name: 'Vietnam', dial_code: '84', code: 'VN' },
  { name: 'Thailand', dial_code: '66', code: 'TH' },
  { name: 'Malaysia', dial_code: '60', code: 'MY' },
  { name: 'Singapore', dial_code: '65', code: 'SG' },
  { name: 'Myanmar', dial_code: '95', code: 'MM' },
  { name: 'Cambodia', dial_code: '855', code: 'KH' },
  { name: 'Laos', dial_code: '856', code: 'LA' },
  { name: 'Sri Lanka', dial_code: '94', code: 'LK' },
  { name: 'Nepal', dial_code: '977', code: 'NP' },
  { name: 'Mongolia', dial_code: '976', code: 'MN' },
  { name: 'Taiwan', dial_code: '886', code: 'TW' },
  { name: 'Hong Kong', dial_code: '852', code: 'HK' },

  // ── Middle East ──
  { name: 'Saudi Arabia', dial_code: '966', code: 'SA' },
  { name: 'United Arab Emirates', dial_code: '971', code: 'AE' },
  { name: 'Qatar', dial_code: '974', code: 'QA' },
  { name: 'Kuwait', dial_code: '965', code: 'KW' },
  { name: 'Bahrain', dial_code: '973', code: 'BH' },
  { name: 'Oman', dial_code: '968', code: 'OM' },
  { name: 'Iraq', dial_code: '964', code: 'IQ' },
  { name: 'Iran', dial_code: '98', code: 'IR' },
  { name: 'Israel', dial_code: '972', code: 'IL' },
  { name: 'Jordan', dial_code: '962', code: 'JO' },
  { name: 'Lebanon', dial_code: '961', code: 'LB' },
  { name: 'Syria', dial_code: '963', code: 'SY' },
  { name: 'Yemen', dial_code: '967', code: 'YE' },
  { name: 'Afghanistan', dial_code: '93', code: 'AF' },
  { name: 'Kazakhstan', dial_code: '7', code: 'KZ' },
  { name: 'Uzbekistan', dial_code: '998', code: 'UZ' },

  // ── Oceania ──
  { name: 'Australia', dial_code: '61', code: 'AU' },
  { name: 'New Zealand', dial_code: '64', code: 'NZ' },
  { name: 'Fiji', dial_code: '679', code: 'FJ' },
  { name: 'Papua New Guinea', dial_code: '675', code: 'PG' },
];

export default countries;